import {
	GetRefundBeneficiaryBankData,
	GetRefundBeneficiaryBankDataResponse,
	GetRefundBeneficiaryBankDataParams,
} from 'domain/usecases';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteRefundGetBeneficiaryBankData implements GetRefundBeneficiaryBankData {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetRefundBeneficiaryBankDataResponse>,
	) {}

	async get(
		params?: GetRefundBeneficiaryBankDataParams,
	): Promise<GetRefundBeneficiaryBankDataResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal: params?.signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
